(function setupBasicInheritedProperties(global) {
  'use strict';

  const basicBlueForm = document.querySelector('[data-basic-blue-form]');
  const basicBottomBlueForm = document.querySelector('[data-basic-bottom-blue-form]');
  const basicStickyButtom = document.querySelector('[data-sticky-basic-lead]');
  const basicCTATopPopup = document.querySelector('[data-cta-top-popup]');
  const positionAttribute = ['data-ga4-event-position', 'data-ga4-position'];

  const setAttribute = (attribute, value, container) => container.querySelectorAll(`[${attribute}]`)
    .forEach((element) => {
      element.setAttribute(attribute, value);
    });

  /**
  * Sets a data layer value for recommendation properties with a position of 'bottom blue form' in mobile.
  */
  const setInheritedBasicBottomBlueFormProperties = () => {
    if (!global.NewHomeSource.Modules.tagManager) {
      return;
    }

    global.NewHomeSource.Modules.tagManager.setDataLayerValue('recommendationProperties', {
      position: 'bottom blue form'
    });
  };

  /**
  * Sets a data layer value for recommendation properties with a position of 'right blue form'.
  */
  const setInheritedBasicBlueFormProperties = () => {
    if (!global.NewHomeSource.Modules.tagManager) {
      return;
    }

    global.NewHomeSource.Modules.tagManager.setDataLayerValue('recommendationProperties', {
      position: 'right blue form'
    });
  };

  /**
  * Sets a data layer value for recommendation properties with a position of 'sticky nav button'.
  */
  const setInheritedBasicStickyProperties = () => {
    if (!global.NewHomeSource.Modules.tagManager) {
      return;
    }

    global.NewHomeSource.Modules.tagManager.setDataLayerValue('recommendationProperties', {
      position: 'stickyheader'
    });
  };

  /**
  * Sets a data layer value for recommendation properties with a position of 'CTA Top Popup' in mobile.
  */
  const setInheritedBasicCTATopPopupProperties = () => {
    if (!global.NewHomeSource.Modules.tagManager) {
      return;
    }

    global.NewHomeSource.Modules.tagManager.setDataLayerValue('recommendationProperties', {
      position: 'Fixed CTAs Mob Top Popup'
    });
  };

  /**
   * ` updates data attributes in a modal based on specific position value retrieved from the tag manager.
   * @param event - is an object that contains details about the event that triggered the function.
   */
  const addRecommendationModalCustomProperties = (event) => {
    const { modal } = event.detail;
    if (!modal || !global.NewHomeSource.Modules.tagManager) {
      return;
    }

    const dataLayerResult = global.NewHomeSource.Modules.tagManager.getFromDataLayer('recommendationProperties');

    if (dataLayerResult && dataLayerResult.position) {
      const { position } = dataLayerResult;
      positionAttribute.forEach((attribute) => setAttribute(attribute, position, modal));
    }
  };

  const config = [
    { element: basicBlueForm, listener: setInheritedBasicBlueFormProperties },
    { element: basicBottomBlueForm, listener: setInheritedBasicBottomBlueFormProperties },
    { element: basicStickyButtom, listener: setInheritedBasicStickyProperties },
    { element: basicCTATopPopup, listener: setInheritedBasicCTATopPopupProperties },
  ];
  config.forEach(({ element, listener }) => {
    if (element) {
      element.addEventListener('click', listener);
    }
  });
  document.body.addEventListener('recommededModalReady', addRecommendationModalCustomProperties);
}(window));
